import React from 'react';
import deviceTypes from '../../../../settings/venue/device/deviceTypes';
import { DisplayField } from '../../../fields/Styles';

const NodeTypeField = props => {
    const displayName = deviceTypes.nodeTypes.find(nt => nt.key === parseInt(props.nodeType))?.display;
    return <DisplayField>{displayName || 'Unknown'}</DisplayField>
}

export default NodeTypeField;